// update log
// FB 4371 DK    03/29/2021    Added for global parameters used all over the site
// FB 4472 DK    05/31/2021    Added new parameter for logo
// FB 6042 DK    05/12/2022    Logo made generic
// FB 6036 MS    05/17/2022    Telehealth Changes
// FB 6099 GS    07/26/2022    Added variable for disabling By Office location button
// FB 6264 DK    11/22/2022    Migrate PE API,DB to EMR
// FB 6632 MS    03/28/2023    Telehealth video is not working
// EMR-131 GA    03/04/2026    Updated Twilio credentials


let config = {
  emrAPI: "https://mbs.mdchartsportal.com/",
  //FB-6264
  digitalApptType: "TeleHealth",
  logoName: "logo",		//FB 6042		Added to specify the logo image name
  trackingID: "UA-201170884-1",    //FB 4533 BR    GA tags for patient engagement
  clientIp: "", //FB 4960
  isByLocationEnabled: false, //FB 6099

  //FB 4661 BR: Start PE - configuring EMR and PE API
  'Mind, Body and Soul Obstetrics & Gynecology': {
    emrAPI: "https://mbs.mdchartsportal.com/"
    //FB-6264
  },
  //FB 6036 BEGIN
  //FB 6632 BEGIN
  //EMR-131 Updated Twilio credentials
  twilio: {
    accountSid: "ACd0ea635ebc472021e056f5d2a66f2072",
    apiKey: "SK74217d7b7664d58bfcb7038b2161412a",
    apiSecret: "mQWX2w6KMuek52DNw1o8KOXyliyOEzF5"
  }
  //FB 6632 END
  //FB 6036 END
  //FB 4661 BR: End PE - configuring EMR and PE API
};
export default config;